export const HighCostLicenseDetailsUat = {
  highCostDetailsTitleText: 'highCostLicenseDetails.title.text',
  highCostDetailsLicenseDetailsText:
    'highCostLicenseDetails.licenseDetails.text',
}
